import type {
  ParkSpaceOperationMode,
  ParkSpaceStatus,
  ParkSpaceType,
} from '@/services/bff/types/park';

export const ALL_SPACES_TREE_KEY = '__all__';

export const spaceTypeText: Record<ParkSpaceType, string> = {
  building: '楼栋',
  floor: '楼层',
  room: '房间',
  workstation: '工位',
  factory: '厂房',
  warehouse: '仓库',
  parking: '停车区域',
  vacant_land: '空地',
  meeting_room: '会议室',
  venue: '场地',
  other: '其他',
  registration_unit: '注册单元',
};

export const operationModeText: Record<ParkSpaceOperationMode, string> = {
  leaseable: '可经营',
  self_use: '园区自用',
  public: '公共房源',
  non_operational: '不参与经营',
  registration_only: '仅注册',
};

export const statusText: Record<ParkSpaceStatus, string> = {
  active: '启用',
  inactive: '停用',
};

/**
 * 带回退的展示取值。
 *
 * 房源类型与经营属性已改为「房源配置」可维护，取值不再限于下面这些内置项，
 * 因此所有展示位都不要直接索引映射（会拿到 undefined 渲染成空白），
 * 统一用这两个函数：内置文案 -> 原始取值。
 * 若页面已经通过 useSpaceConfig 读到最新字典，优先用它的 labelOf（能带上用户改过的名称）。
 */
export const spaceTypeLabel = (code?: string | null): string =>
  code ? (spaceTypeText[code] ?? code) : '-';

export const operationModeLabel = (code?: string | null): string =>
  code ? (operationModeText[code] ?? code) : '-';

export const displayStatusColor: Record<string, string> = {
  occupied: 'success',
  vacant: 'blue',
  self_use: 'processing',
  public: 'purple',
  non_operational: 'default',
};

export const occupancyFilterOptions = [
  { value: 'all', label: '全部' },
  { value: 'occupied', label: '已占用' },
  { value: 'vacant', label: '空置' },
] as const;
